import axios from 'axios';
import authHeader from "./auth-header";

class GenreService {
    getGenres() {
        return axios.get(window.api_url + "/api/genres");
    }

    getGenre(id){
        return axios.get(window.api_url + "/api/auth/genre/" + id + "/show",  { headers: authHeader() });
    }

    updateGenre(id, name){
        const formData = new FormData();
        formData.append('name', name);
        return axios.post(window.api_url + "/api/auth/genre/" + id, formData,  { headers: authHeader() });
    }

    addGenre(name) {
        let formData = new FormData();
        formData.append('name', name);
        return axios.post(window.api_url + "/api/auth/genre", formData, { headers: authHeader() });
    }

    getGamesAuth(id){
        return axios.get(window.api_url + "/api/auth/genre/" + id,  { headers: authHeader() });
    }

    getGames(id){
        return axios.get(window.api_url + "/api/genre/" + id);
    }

    deleteGenre(id){
        return axios.delete(window.api_url + "/api/auth/genre/" + id,  { headers: authHeader() });
    }

}

export default new GenreService();